<template lang="pug">
modal#qualified-signature-plugin-authorize-modal(
  :no-footer='true'
  :title='$t("modal.qualifiedSignatureCertificatePluginModal.authorization.title")'
  @closed='$emit("closed")'
  data-bs-backdrop='static'
  data-bs-keyboard='false'
  ref='modal'
  size='lg'
)
  .body-wrapper
    iframe.iframe(
      :class='{ hide: hide }'
      :src='link'
      height='560'
      ref='iframe'
      width='100%'
    )
    button.btn.btn-primary(
      :style='{ visibility: showProceedButton ? "visible" : "hidden" }'
      @click='$emit("proceed")'
    ) Continuar
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'QualifiedSignaturePluginAuthorizeModal',
  components: {
    Icon,
    Modal,
  },
  props: {
    showProceedButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      link: '',
      hide: true,
    };
  },
  mounted() {
    this.$refs.iframe.onload = () => {
      this.$refs.iframe.src = this.link;
      setTimeout(() => {
        this.hide = false;
      }, 500);
    };
  },
};
</script>
<style lang="stylus">
.body-wrapper
  display: flex
  flex-direction: column
.qualified-signature-plugin-authorize-modal
  .iframe
    opacity: 1
    &.hide
      opacity: 0
  button.btn.btn-primary
    align-self: flex-end
</style>
